import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {Toast} from 'primereact/toast';
import * as actions from '../../store/actions/index';
import { GET_LANDING_PATH, IS_SIGNED_IN } from '../../shared/utility';

class LoginWithPhone extends Component{


    state = {
        phoneNumber : '123456789', //+966542613691 
        otp:''
    }

    handleSubmit = () => {
        if(this.state.phoneNumber !== ''){
            this.props.onAuth(this.state.phoneNumber, '', false, true);
        } else {
            this.growl.show({severity: 'error', summary: null, detail: 'Please enter phone number'});
        }
    }

    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({[name]:value});
    }
    
    verfiyOTP = () => {
        if(this.state.otp !== ''){
            if(parseInt(this.props.mobileVerify) === parseInt(this.state.otp)){
                this.props.verifiedOTP(this.props.mobileVerify);
            }else{
                this.growl.show({severity: 'error', summary: null, detail: 'OTP is not valid'});
            }      
        } else {
            this.growl.show({severity: 'error', summary: null, detail: 'Please enter OTP number'});
        }
    }

    render(){
        // Same gate as the other login screens: the token is non-null before
        // anyone signs in (see IS_SIGNED_IN), so an OTP login has to be confirmed
        // by the authentication response itself — which also names where this user
        // belongs, instead of everyone landing on /dashboard.
        let redirectUrl = null
        if(this.props.signedIn){
            redirectUrl = <Redirect to={this.props.landingPath}/>
        }
     
        let html = (<div> 
                        <h2 className="login-title">Login With Phone</h2>
                        <p>Please enter your registered phone number.</p>
                        <form className="login-form" onSubmit={e => {e.preventDefault();}}>
                            <fieldset>
                                <label htmlFor="phoneNumber" className="phone login-label">Phone Number</label>
                                <input type="text"  onChange={this.onChange} name="phoneNumber" placeholder="Enter your phone number" value={this.state.phoneNumber} autoComplete="off" className="login-control" />
                            </fieldset>
                            <fieldset>
                                <input type="submit" value="Send OTP" name="submit" id="phoneNumber" className="login-button"  onClick={this.handleSubmit} />
                            </fieldset>
                        </form>
                    </div>);

        if(this.props.mobileVerify!==null){
            html = (<div> 
                <h2 className="login-title">Verify OTP</h2>
                <p>Please enter 6 digit OTP your received</p>
                <form className="login-form" onSubmit={e => {e.preventDefault();}}>
                    <fieldset>
                        <label htmlFor="phoneNumber" className="phone login-label">OTP Number</label>
                        <input type="text"  onChange={this.onChange} name="otp" placeholder="Enter OTP" value={this.state.otp} autoComplete="off" className="login-control" />
                    </fieldset>
                    <fieldset>
                        <input type="submit" value="Verify OTP" name="submit" className="login-button"  onClick={this.verfiyOTP} />
                    </fieldset>
                </form>
            </div>);
        }
      
        return(
            <div className="forgot-password-container">
                 { this.props.loading && <div className="page-loader"></div>}   
                <Toast ref={(el) => this.growl = el} />
                {redirectUrl}
                {html}
            </div>
        );
    }
}



const mapStateToProps = state => {
    return {
        error : state.auth.error,
        loading : state.auth.loading,
        mobileVerify: state.auth.mobileVerify,
        signedIn : IS_SIGNED_IN(state.auth),
        landingPath : GET_LANDING_PATH(state.auth.userPosInfo)
    }
}

const mapDispatchToProps = dispatch => {
    return{
        onAuth : (email, password, isSignUp, mobile) => dispatch(actions.auth(email, password, isSignUp, mobile)),
        verifiedOTP : (code) => dispatch(actions.verifiedOTP(code)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithPhone);